import _pt from "prop-types";
import * as React from 'react';
import { LinkContext } from './LinkContext';
export var LinkProvider = function LinkProvider(props) {
  var _props$custom = props.custom,
    custom = _props$custom === void 0 ? null : _props$custom,
    children = props.children;
  var getCustomLinkDefinition = function getCustomLinkDefinition() {
    return custom;
  };
  return /*#__PURE__*/React.createElement(LinkContext.Provider, {
    value: {
      getCustomLinkDefinition: getCustomLinkDefinition
    }
  }, children);
};
LinkProvider.propTypes = {
  /**
     * If you want to render a custom component, such as the Link component from react-router, you pass it in through this property.
     * Additionally if the target prop name isn't href you must specify the name in mapHrefToProp.
     * In the case of react-router-dom you would set the value to 'to'.
     */
  custom: _pt.shape({
    component: _pt.any,
    mapHrefToProp: _pt.string
  }),
  children: _pt.node
};